import { render, staticRenderFns } from "./BaseChatScroll.vue?vue&type=template&id=2ad6d83e&scoped=true&"
import script from "./BaseChatScroll.vue?vue&type=script&lang=ts&"
export * from "./BaseChatScroll.vue?vue&type=script&lang=ts&"
import style0 from "./BaseChatScroll.vue?vue&type=style&index=0&id=2ad6d83e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6d83e",
  null
  
)

export default component.exports